import * as React from "react";
import { cn } from "./cn";

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * Skeleton loading placeholder with pulse animation.
 *
 * @example
 * // Basic skeleton
 * <Skeleton className="h-4 w-[200px]" />
 *
 * // Card skeleton
 * <div className="space-y-3">
 *   <Skeleton className="h-[125px] w-full rounded-xl" />
 *   <Skeleton className="h-4 w-[250px]" />
 *   <Skeleton className="h-4 w-[200px]" />
 * </div>
 *
 * // Avatar skeleton
 * <Skeleton className="h-12 w-12 rounded-full" />
 */
function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-surface-2", className)}
      {...props}
    />
  );
}

export { Skeleton };
